import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TriviaService, TriviaResult } from '../../_services/trivia-service';
import { map } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-trivia-results',
  templateUrl: './trivia-results.component.html',
  styleUrls: [
    './trivia-results.component.css',
    '../../_shared/base.management.component.css'
  ]
})
export class TriviaResultsComponent implements OnInit {
  displayItems: TriviaResult[];
  triviaId = 0;
  serviceId = 0;
  loading = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private triviaService: TriviaService,
    private datePipe: DatePipe,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.loading = true;
    this.spinner.show();
    this.route.params
      .subscribe(rp => {
        this.triviaId = +rp['triviaId'];
        this.serviceId = +rp['serviceId'];
        this.triviaService.getTriviaResultsList(this.triviaId).subscribe(result => {
          this.displayItems = result;
          this.loading = false;
          this.spinner.hide();
        },
        err => {
          this.loading = false;
          this.spinner.hide();
          this.router.navigate([`/portal/trivia/`, this.triviaId]);
        });
      });
  }

  viewDetails(serviceId: number, triviaId: number, serviceLogId: number) {
    this.router.navigate([`/portal/trivia/results/${serviceId}/${triviaId}/${serviceLogId}`]);
  }

  public downloadDetails(row: TriviaResult) {
    this.triviaService.getTriviaResultCSV(row.triviaGameId, row.serviceLogId).subscribe(blob => {
      const url = window.URL.createObjectURL(blob);
      const anchor: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
      anchor.href = url;
      const pipeDate = this.datePipe.transform(row.date, 'yyyy-MM-dd');
      anchor.download = `trivia-game-result-details-${this.triviaId}-${row.serviceLogId}-${pipeDate}.csv`;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(url);
    });
  }

  back() {
    this.router.navigate([`/portal/trivia/`, this.serviceId, this.triviaId]);
  }
}
